export default "__VITE_ASSET__DHMMLELN__"